import { render } from "./layouts-header.vue?vue&type=template&id=0b15d09e"
import script from "./layouts-header.vue?vue&type=script&lang=js"
export * from "./layouts-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__